import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62c84bff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trading-rules" }
const _hoisted_2 = { class: "rule-section" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("1.买入规则 ")
const _hoisted_4 = { class: "tag-group" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "rule-section" }
const _hoisted_8 = { class: "tag-group" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "tag-remove"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 自定义")
const _hoisted_12 = {
  key: 0,
  class: "tag-remove"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" B. 指标信号卖出 ")
const _hoisted_14 = {
  key: 0,
  class: "ind-selected-tag"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "×", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "tag-group indicator-group" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "indicator-name" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "indicator-desc-text" }
const _hoisted_22 = { class: "ind-popup-header" }
const _hoisted_23 = { class: "ind-popup-title" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fi-multi-tag" }, "单选", -1))
const _hoisted_25 = { class: "ind-popup-options" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "ind-popup-footer" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "stop-row" }
const _hoisted_30 = { class: "stop-group" }
const _hoisted_31 = { class: "stop-inline" }
const _hoisted_32 = {
  key: 0,
  class: "stop-error"
}
const _hoisted_33 = { class: "stop-group" }
const _hoisted_34 = { class: "stop-inline" }
const _hoisted_35 = {
  key: 0,
  class: "stop-error"
}
const _hoisted_36 = { class: "stop-group" }
const _hoisted_37 = { class: "stop-inline" }
const _hoisted_38 = {
  key: 0,
  class: "stop-error"
}
const _hoisted_39 = { class: "stop-group" }
const _hoisted_40 = { class: "stop-inline" }
const _hoisted_41 = {
  key: 0,
  class: "stop-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "rule-title",
        style: _normalizeStyle({ color: _ctx.colors.textPrimary })
      }, [
        _hoisted_3,
        _createElementVNode("span", {
          class: "rule-hint",
          style: _normalizeStyle({ color: _ctx.colors.textMuted })
        }, "买入时间：T+1开盘", 4)
      ], 4),
      _createElementVNode("div", {
        class: "rule-label",
        style: _normalizeStyle({ color: _ctx.colors.textMuted })
      }, "买入优先级", 4),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buyPriorityOptions, (opt) => {
          return (_openBlock(), _createElementBlock("div", {
            key: opt.value,
            class: "tag-item",
            style: _normalizeStyle(_ctx.tagStyle(_ctx.buyPriorities.includes(opt.value))),
            onClick: ($event: any) => (_ctx.toggleBuyPriority(opt.value))
          }, [
            _createTextVNode(_toDisplayString(opt.label) + " ", 1),
            _createElementVNode("span", {
              class: "tag-remove",
              style: _normalizeStyle({ opacity: _ctx.buyPriorities.includes(opt.value) ? 1 : 0, pointerEvents: _ctx.buyPriorities.includes(opt.value) ? 'auto' : 'none' }),
              onClick: _withModifiers(($event: any) => (_ctx.toggleBuyPriority(opt.value)), ["stop"])
            }, "×", 12, _hoisted_6)
          ], 12, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "rule-title",
        style: _normalizeStyle({ color: _ctx.colors.textPrimary })
      }, "2.卖出规则", 4),
      _createElementVNode("div", {
        class: "rule-label",
        style: _normalizeStyle({ color: _ctx.colors.textMuted })
      }, "A. 持股周期卖出", 4),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.holdDayOptions, (opt) => {
          return (_openBlock(), _createElementBlock("div", {
            key: opt.value,
            class: _normalizeClass(["tag-item", { selected: _ctx.holdDays.includes(opt.value) }]),
            style: _normalizeStyle(_ctx.tagStyle(_ctx.holdDays.includes(opt.value))),
            onClick: ($event: any) => (_ctx.toggleHoldDay(opt.value))
          }, [
            _createTextVNode(_toDisplayString(opt.label) + " ", 1),
            (_ctx.holdDays.includes(opt.value))
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "×"))
              : _createCommentVNode("", true)
          ], 14, _hoisted_9))
        }), 128)),
        _createElementVNode("div", {
          class: _normalizeClass(["tag-item", { selected: _ctx.holdDays.includes('custom') }]),
          style: _normalizeStyle(_ctx.tagStyle(_ctx.holdDays.includes('custom'))),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleHoldDay('custom')))
        }, [
          _hoisted_11,
          (_ctx.holdDays.includes('custom'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "×"))
            : _createCommentVNode("", true)
        ], 6),
        (_ctx.holdDays.includes('custom'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("input", {
                class: "inline-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customHoldDay) = $event)),
                placeholder: "请输入",
                style: _normalizeStyle(_ctx.inputStyle)
              }, null, 4), [
                [_vModelText, _ctx.customHoldDay]
              ]),
              _createElementVNode("span", {
                style: _normalizeStyle({ color: _ctx.colors.textMuted })
              }, "天", 4)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "rule-label",
        style: _normalizeStyle({ color: _ctx.colors.textMuted })
      }, [
        _hoisted_13,
        (_ctx.indicators.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("span", null, "当前已选：" + _toDisplayString(_ctx.indicators.map(v => {
            const opt = _ctx.indicatorOptions.find((o) => o.value === v)
            const subName = _ctx.selectedIndicatorOptions[v] ? _ctx.getOptionName(v, _ctx.selectedIndicatorOptions[v]) : ''
            return opt ? (subName ? `${opt.label}:${subName}` : opt.label) : v
          }).join('，')), 1),
              _createElementVNode("div", {
                class: "ind-selected-tag-close",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearIndicators && _ctx.clearIndicators(...args)))
              }, _hoisted_16)
            ]))
          : _createCommentVNode("", true)
      ], 4),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicatorOptions, (opt) => {
          return (_openBlock(), _createElementBlock("div", {
            key: opt.value,
            class: "indicator-wrap"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["tag-item indicator-item", { selected: _ctx.indicators.includes(opt.value) }]),
              style: _normalizeStyle(_ctx.tagStyle(_ctx.indicators.includes(opt.value))),
              onClick: ($event: any) => (_ctx.openIndicatorPopup(opt, $event))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createTextVNode(_toDisplayString(opt.label) + " ", 1),
                (_ctx.indicators.includes(opt.value))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "tag-remove",
                      onClick: _withModifiers(($event: any) => (_ctx.removeIndicator(opt.value)), ["stop"])
                    }, "×", 8, _hoisted_20))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "indicator-desc",
                style: _normalizeStyle({ color: _ctx.indicators.includes(opt.value) ? '#e8392a' : _ctx.colors.textMuted })
              }, [
                (_ctx.isIndicatorDescOverflow(opt.sub))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      title: opt.sub,
                      placement: "top",
                      "arrow-point-at-center": ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatIndicatorDesc(opt.sub)), 1)
                      ]),
                      _: 2
                    }, 1032, ["title"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(opt.sub), 1)
                    ], 64))
              ], 4)
            ], 14, _hoisted_18)
          ]))
        }), 128))
      ]),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_ctx.indicatorPopup.visible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ind-mask",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancelIndicatorPopup && _ctx.cancelIndicatorPopup(...args)), ["self"]))
            }, [
              _createElementVNode("div", {
                class: "ind-popup",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, [
                    _createTextVNode(_toDisplayString(_ctx.indicatorPopup.label) + " ", 1),
                    _hoisted_24
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicatorPopup.options, (subOpt) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: subOpt.optionCode,
                      class: "ind-option-item",
                      style: _normalizeStyle({
                  background: _ctx.indicatorPopup.selected.includes(subOpt.optionCode) ? '#FFEDED' : '#f0f0f0',
                  color: _ctx.indicatorPopup.selected.includes(subOpt.optionCode) ? '#1a1a1a' : '#1a1a1a',
                  borderColor: _ctx.indicatorPopup.selected.includes(subOpt.optionCode) ? '#e8392a' : 'transparent'
                }),
                      onClick: ($event: any) => (_ctx.togglePopupOption(subOpt.optionCode))
                    }, _toDisplayString(subOpt.optionName), 13, _hoisted_26))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    class: "ind-btn-cancel",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelIndicatorPopup && _ctx.cancelIndicatorPopup(...args)))
                  }, "取消"),
                  _createElementVNode("button", {
                    class: _normalizeClass(["ind-btn-confirm", { 'ind-btn-confirm--disabled': !_ctx.canConfirmIndicator }]),
                    disabled: !_ctx.canConfirmIndicator,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirmIndicatorPopup && _ctx.confirmIndicatorPopup(...args)))
                  }, "确定", 10, _hoisted_28)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])),
      _createElementVNode("div", {
        class: "rule-label",
        style: _normalizeStyle({ color: _ctx.colors.textMuted })
      }, "C. 止盈止损卖出", 4),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("label", {
              style: _normalizeStyle({ color: _ctx.colors.textSecondary })
            }, "止盈收益率 ≥", 4),
            _withDirectives(_createElementVNode("input", {
              class: "stop-input",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stopProfit) = $event)),
              placeholder: "请输入",
              style: _normalizeStyle(_ctx.inputStyle),
              onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateStop('profit', _ctx.stopProfit)))
            }, null, 36), [
              [_vModelText, _ctx.stopProfit]
            ]),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "%", 4)
          ]),
          (_ctx.stopErrors.profit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.stopErrors.profit), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("label", {
              style: _normalizeStyle({ color: _ctx.colors.textSecondary })
            }, "止损收益率 ≤", 4),
            _createElementVNode("span", {
              class: "stop-sign",
              style: _normalizeStyle({ color: _ctx.colors.textSecondary })
            }, "-", 4),
            _withDirectives(_createElementVNode("input", {
              class: "stop-input",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.stopLoss) = $event)),
              placeholder: "请输入",
              style: _normalizeStyle(_ctx.inputStyle),
              onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onStopLossInput && _ctx.onStopLossInput(...args)))
            }, null, 36), [
              [_vModelText, _ctx.stopLoss]
            ]),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "%", 4)
          ]),
          (_ctx.stopErrors.loss)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.stopErrors.loss), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("label", {
              style: _normalizeStyle({ color: _ctx.colors.textSecondary })
            }, "个股收益 ≥", 4),
            _withDirectives(_createElementVNode("input", {
              class: "stop-input",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.stockLoss) = $event)),
              placeholder: "请输入",
              style: _normalizeStyle(_ctx.inputStyle),
              onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validateStop('stock', _ctx.stockLoss)))
            }, null, 36), [
              [_vModelText, _ctx.stockLoss]
            ]),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "%", 4)
          ]),
          (_ctx.stopErrors.stock)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.stopErrors.stock), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("label", {
              style: _normalizeStyle({ color: _ctx.colors.textSecondary })
            }, "最高收益回落 ≥", 4),
            _withDirectives(_createElementVNode("input", {
              class: "stop-input",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.maxDrawdown) = $event)),
              placeholder: "请输入",
              style: _normalizeStyle(_ctx.inputStyle),
              onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.validateStop('drawdown', _ctx.maxDrawdown)))
            }, null, 36), [
              [_vModelText, _ctx.maxDrawdown]
            ]),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.colors.textMuted })
            }, "%", 4)
          ]),
          (_ctx.stopErrors.drawdown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.stopErrors.drawdown), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "rule-label",
        style: _normalizeStyle({ color: _ctx.colors.textMuted })
      }, "D. 触发信号后卖出时间", 4),
      _createElementVNode("div", {
        class: "rule-label",
        style: _normalizeStyle({ color: _ctx.colors.textMuted })
      }, "触发信号后冒出时间：T+1开盘", 4)
    ])
  ]))
}